<template>
  <b-card no-body>
    <b-card-body>
      <div class="p-1 mb-1 bg-light-primary rounded">
        <b-card-text>
          Para realizar el <b>cambio de contraseña de su plataforma de Campus/Academia</b>, ingrese su contraseña actual, posteriomente presione el botón <b>"Verificar identidad"</b>, es importante saber que esta acción cerrará su sesión, por ello, le pedimos que una vez realizado el cambio de contraseña, <b>inicie sesión nuevamente con la nueva contraseña asignada</b>.
        </b-card-text>
      </div>

      <b-row>
        <b-col />
        <b-col
          lg="4"
          md="8"
          sm="12"
        >
          <div v-if="!showLoader">
            <validation-observer ref="formularioVerify">
              <b-form
                class="auth-reset-password-form my-2"
                @submit.prevent="validationForm"
              >
                <!-- password -->
                <b-form-group
                  label="Contraseña"
                  label-for="reset-password-new"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="contraseña"
                    vid="Password"
                    rules="required|password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="reset-password-new"
                        v-model="password"
                        :type="password1FieldType"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        name="reset-password-new"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password1ToggleIcon"
                          @click="togglePassword1Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- confirm password -->
                <b-form-group
                  label-for="reset-password-confirm"
                  label="Confirmar contraseña"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="confirmar contraseña"
                    rules="required|confirmed:Password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="reset-password-confirm"
                        v-model="cPassword"
                        :type="password2FieldType"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false:null"
                        name="reset-password-confirm"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="password2ToggleIcon"
                          @click="togglePassword2Visibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- submit button -->
                <b-button
                  block
                  type="submit"
                  variant="primary"
                >
                  <feather-icon
                    icon="KeyIcon"
                    class="mr-50"
                  />
                  <span class="align-middle">Verificar identidad</span>
                </b-button>
              </b-form>
            </validation-observer>
          </div>
          <div v-else>

            <div class="pt-3">
              <b-progress
                animated
                value="100"
                class="progress-bar-primary"
                variant="primary"
              />

              <div class="text-center mt-1 mb-2">
                <span>Verificando ...</span>
              </div>
            </div>
          </div>
        </b-col>
        <b-col />
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard,
  BRow,
  BCol,
  BCardText,
  BCardBody,
  BButton,

  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  // BOverlay,
  BProgress,
  BFormInput,
} from 'bootstrap-vue'
import { ref, computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { formhttp } from '@core/utils/utils'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { logout } from '@/auth/utils'
import { checkPassAccount } from './useCuenta'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BCardText,
    BCardBody,

    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    // BOverlay,
    BProgress,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  setup() {
    const toast = useToast()
    const cPassword = ref('')
    const password = ref('')
    const password1FieldType = ref('password')
    const password2FieldType = ref('password')
    const formularioVerify = ref(null)
    const showLoader = ref(false)
    const { cleanUserData } = logout()

    //* Change type input to see password (pass)
    const togglePassword1Visibility = () => {
      password1FieldType.value = password1FieldType.value === 'password' ? 'text' : 'password'
    }

    //* Change type input to see password (confirm pass)
    const togglePassword2Visibility = () => {
      password2FieldType.value = password2FieldType.value === 'password' ? 'text' : 'password'
    }

    //* Change icon in inputs (Eye)
    const password1ToggleIcon = computed(() => (password1FieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))
    const password2ToggleIcon = computed(() => (password2FieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon'))

    //* Check current pass, then redirect to change it
    const verifyPass = () => {
      showLoader.value = true
      checkPassAccount(password.value)
        .then(response => {
          const { icon, label } = formhttp(response.status)
          showLoader.value = false

          if (response.status === 200) {
            const { m, k } = response.data
            cleanUserData(false, `/auth/reset-pass/${m}/${k}/${store.state.cuenta.session.persona}`)
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Verificación de identidad',
                text: response.message,
                icon,
                variant: label,
              },
            },
            { timeout: 8000 })
          }
        }, error => {
          showLoader.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Verificación de identidad',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    //* Validate form
    const validationForm = () => {
      formularioVerify.value.validate().then(success => {
        if (success) verifyPass()
      })
    }

    return {
      // Variables
      cPassword,
      password,
      password1FieldType,
      password2FieldType,

      // Flags
      showLoader,

      // Methods
      togglePassword1Visibility,
      togglePassword2Visibility,
      validationForm,

      // Computed
      password1ToggleIcon,
      password2ToggleIcon,

      // Refs
      formularioVerify,

      // Filters
      required,
    }
  },
}
</script>
